const TOLERANCE = 0.01

const round = (n, decimals) => {
  const f = 10 ** decimals
  return Math.round((n + Number.EPSILON) * f) / f
}

export function compareTotals ({ invoiceTotal, primkaTotal, depositTotal }) {
  [invoiceTotal, primkaTotal, depositTotal].forEach(value => {
    if (typeof value !== 'number' || !Number.isFinite(value)) throw new TypeError('totals must be finite numbers')
  })
  const raw = primkaTotal + depositTotal - invoiceTotal
  // diff is rounded to 2 decimals but matches uses the raw difference, so at the 0.01 boundary they can
  // disagree (diff 0.01, matches false); callers must rely on matches.
  return {
    matches: Math.abs(round(raw, 6)) <= TOLERANCE,
    diff: round(raw, 2)
  }
}
